import {Component, OnInit} from '@angular/core';

import {from, Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';

import {TranslateService} from '@ngx-translate/core';
import {I18n} from 'src/common';
import {DataService} from '../services/dataService';

const DATA_VALIDITY_CODE = 'Validité données';

@Component({
    selector: 'app-data-validity-mention',
    templateUrl: './data-validity-mention.component.html',
    styleUrls: ['./data-validity-mention.component.scss']
})
export class DataValidityMentionComponent implements OnInit {

    dataValidityI18nText$: Observable<I18n>;

    constructor(
        private _dataService: DataService,
        private _translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.dataValidityI18nText$ =
            from(this._dataService.getI18ns())
                .pipe(
                    switchMap(
                        (i18ns: I18n[]) => {
                            const i18nText: I18n = i18ns.find(
                                (e: I18n) => e.code === DATA_VALIDITY_CODE && e.lang === this._translateService.currentLang);
                            if (i18nText) {
                                return of(i18nText);
                            }
                            return of(null);
                        }
                    )
                );
    }

}
